import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

@Injectable({
  providedIn: 'root'
})


export class LoginService {

  constructor(private http: HttpClient) { }
  
  
  validarUsuario(email: string, clave: string)
  {
  console.log(environment.apiUrl+"/login/?clave="+clave+"&"+"email="+email);
 
    return this.http.get(environment.apiUrl+"/login/?clave="+clave+"&"+"email="+email); 
  }
  
    
  
}
